import root, { moduleName as rootStore } from 'Root/redux/root.redux';


export default {
  [rootStore]: root,
};



// WEBPACK FOOTER //
// ./src/Root/RootStore.js